<template>
  <div class="content" style="width: 100%">
    <div>
      <a-button @click="isOpen" class="btaction" >点击上传</a-button>
    </div>
    <a-modal
      :closable="false"
      :visible="sdpvisibles"
      :width="500"
      :dialog-style="{ top: '25%' }"
      @cancel="handleCancel"
    >
    <div class="tip-icon" slot="title"> 上传 </div>
      <a-spin tip="加载中..." :spinning="spinning">
        <a-upload-dragger
          :file-list="fileList"
          @change="handleChange"
          :remove="handleRemove"
          :beforeUpload="beforeUpload"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" style="color:rgba(22, 130, 139, 1);" />
          </p>
          <p class="ant-upload-text">点击或将文件拖拽到这里上传</p>
        </a-upload-dragger>
      </a-spin>
      <template slot="footer">
        <a-button @click="handleCancel">取消</a-button>
        <a-button
          :disabled="fileList.length <= 0"
          type="primary"
          :loading="loading"
          @click="handleSubmit"
          >上传</a-button
        >
      </template>
    </a-modal>
    <div
      style="
        overflow: auto;
        width: 100%;
      
        display: flex;
        flex-wrap: wrap;
        justify-content: start;
      "
    >
      <div class="box" v-for="(item, index) in queryList" :key="index" v-if="fileType == '01' || fileType == undefined">
        <div class="mydiv">
          <img :src="codeimg + item.id" alt="" @click="handleImg(item.id)"/>
          <div style="background-color: rgba(255, 255, 255, 0.8);position: absolute;z-index: 8;top: 0;right: 0;;width: 25px;height: 25px;">
            <a-icon class="close" type="delete" @click="dele(item)" />
          </div>
        </div>
      </div>
      <div class="box" style="width: 100px;" v-for="(item, index) in queryList" :key="index" v-if="fileType == '02' ">
        <div class="mydiv">
          <a-icon  type="video-camera" theme="filled" :style="{ fontSize: '50px'}"/>
          <div style="background-color: rgba(255, 255, 255, 0.8);position: absolute;z-index: 8;top: 0;right: 0;;width: 25px;height: 25px;">
            <a-icon class="close" type="delete" @click="dele(item)" />
          </div>
        </div>
      </div>
      <!-- 放大图片 -->
      <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancelImg" class="imgBox" >
          <img alt="example" style="max-width: 100%;height: auto;" :src="previewImage" />
        </a-modal>
    </div>
  </div>
</template>

<script scoped>
import {
  uploadFileBatch,
  queryFileBatch,
  downloadFile,
  deleFile,
} from '@/api/api.js'
export default {
  name: 'child',
  data() {
    return {
      sdpvisibles: false,
      fileList: [],
      loading: false,
      spinning: false,
      querying: false,
      total: 0,
      codeimg: process.env.VUE_APP_PROXY + 'base/file/download-file?id=',
      queryList: [],
      pageParam: {
        orderBy: '',
        pageNum: 1,
        pageSize: 10,
      },
      sdpvisible: false,
      visible: false,
      message: '',
      lim: true,
      busId: '',
      checkupload : false,
      previewVisible: false,
      previewImage: "",
      bigurl: "",
    }
  },
  props: {
    downid: String,
    uploadNum:String, //允许上传个数
    uploadAgain:Boolean,//是否再次上传
    fileNum:Number, //监听文件上传个数变化
    fileType: String, //允许上传文件类型
  },
  //初始化（获取新增业务ID）
  created(){
    if(this.downid != "" && this.downid != undefined && this.downid != null){
      this.busId = this.downid;//获取传递ID
      this.query();
      if( this.uploadNum !== undefined &&  this.uploadNum != null && this.uploadNum != ""){
        this.checkupload = true;
      }
    }
    
  },
  watch: {
    //监听修改页面业务ID变化（监听不到新增业务ID值变化）
    downid(val) {
      if(val != "" && val != undefined && val != null){
        this.busId = val;
        this.query();
        if( this.uploadNum !== undefined &&  this.uploadNum != null && this.uploadNum != ""){
          this.checkupload = true;
        }
      }
    },
    fileType(val) {
      this.fileType = val;
    }
  },
  methods: {
    /* 表格图片查看 */
    handleImg(file) {
      this.previewVisible = true;
      this.bigurl = process.env.VUE_APP_PROXY + "base/file/download-file?id=";
      this.previewImage = this.bigurl + file;
    },
    /* 表格图片关闭 */
    handleCancelImg() {
      this.previewVisible = false;
    },
    query() {
      queryFileBatch({ busId: this.busId }).then(
        (res) => {
          this.queryList = res.content

          this.$emit('listen', res.content)
        },
        (err) => {
          this.$message.error('查询图片失败')
        }
      )
    },
    handleCancel() {
      this.sdpvisibles = false
      this.fileList = []
    },
    //是否打开上传文件
    isOpen(){
      this.sdpvisibles = true;
      if(!!this.uploadAgain){
        this.$message.warning('仅支持上传'+this.uploadNum+'个文件')
        this.sdpvisibles = false;
      }
    },
    as() {
      let arr = [1, 2, 3, 4]
      var someResult = arr.every((item) => {
        return item === 4
      })
    },

    beforeUpload(file) {
      if ((this.fileType == undefined || this.fileType == '01') && file.type !== 'image/png' && file.type !== 'image/jpeg') {
        this.$message.error('仅支持上传jpg/png格式的文件')
        return false
      }else if(this.fileType == '02' && file.type !== 'video/mp4') {
        this.$message.error('仅支持上传mp4格式的文件')
        return false
      }else {
        this.fileList = [...this.fileList]
        return false
      }
    },
    //判断数组是否有重复值
    a(arr) {
      var hash = {}
      for (var i in arr) {
        if (hash[arr[i]]) {
          return true
        }
        hash[arr[i]] = true
      }
      return false
    },
    handleChange(file) {
      //获取file文件中的fileList放在一个数组里
      let sz = file.fileList
      //创建一个新数组
      let sz1 = []
      let asdasd = []
      //判断file文件如果有值的情况下，循环sz数组，取到sz数值中的文件名称push到sz1数组中
      if (file) {
        sz.forEach((a) => {
          sz1.push(a.name)
        })
      }

      let list = []
      //获取旧的fileList数组并遍历，取出名字放到list数组中
      this.fileList.forEach((a) => {
        list.push(a.name)
      })
      //调用查看是否有重复值方法，传入sz1数组
      if (this.a(sz1)) {
        //判断在旧的数组中有没有和file.name名字相同的文件
        if (list.includes(file.file.name)) {
          event.target.value = ''
          //有的话不进行处理，让就是fileList数组等于旧的fileList数组
          this.fileList = this.fileList
        } else {
          //如果没有的话，去重掉本次file数组中fileList数组中的重复数据，并赋值给newArr数组
          let hash = {}
          var newArr = file.fileList.reduce((item, next) => {
            hash[next.name] ? '' : (hash[next.name] = true && item.push(next))
            return item
          }, [])
          //把新获得的newArr数组等给fileList数组
          this.fileList = newArr
        }
        //判断lim是不是等于true
        if (this.lim) {
          this.$message.error('禁止重复上传！')
          this.lim = false
          //此定时器用来禁止传多个文件时，提醒多次
          setTimeout(() => {
            this.lim = true
          }, 1000)
        }
        return false
      }
      let name = file.file.name
        .substring(file.file.name.lastIndexOf('.') + 1)
        .toLowerCase()
      //展示上传的图片文件 
      if (name == 'jpg' || name == 'png' && (this.fileType == undefined || this.fileType == '01')) {
        let { fileList } = file
        this.fileList = fileList
      }
      //展示上传的mp4文件
      if (name == 'mp4' && this.fileType == '02') {
        let { fileList } = file
        this.fileList = fileList
      }
    },

    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
    handleSubmit() {
      if (this.fileList.length <= 0) {
        this.$message.warning('请选择上传的文件')
        return false
      }
      
      if(!!this.checkupload && (this.fileList.length + this.fileNum) > this.uploadNum){
        if(this.fileNum !== undefined && this.fileNum > 0){
          this.$message.warning('已上传'+ this.fileNum +'个文件，仅需上传'+(this.uploadNum - this.fileNum)+'个文件');
        }else{
          this.$message.warning('仅支持上传'+this.uploadNum+'个文件');
        }
        return false
      }

      this.loading = true
      this.spinning = true

      var formData = new FormData();
      this.fileList.forEach((e) => {
        formData.append('files', e.originFileObj)
      })
      formData.append('busId', this.busId)

      uploadFileBatch(formData)
        .then((res) => {
          this.sdpvisibles = false
          this.loading = false
          this.spinning = false

          this.fileList = []
          this.query()
          this.$message.success('添加成功')
        })
        .catch((err) => {
          this.$message.error('添加失败')
        })
    },
    dele(eve) {
      this.$confirm({
        title: '确定是否删除?',
        okText: '是',
        cancelText: '否',
        onOk: () => {
          this.querying = true
          deleFile({ id: eve.id }).then(
            (res) => {
              this.querying = false
              this.$message.success('删除成功')                              
              this.query()
            },
            (err) => {
              this.querying = false
              this.$message.error('删除失败')
            }
          )
        },
        onCancel: () => {},
      })
    },
  },
}
</script>

<style lang="less" scoped>
.btaction {
    background: rgba(22, 130, 139, 1);
    border-color: rgba(22, 130, 139, 1);
    margin-right: 10px;
    color: white;
}

.box:nth-child(4n+1){
  margin-left: 0px;
}
.box{
  margin-left: 20px;border: 1px solid #d9d9d9;
  margin-top: 10px;
   width: 182px;;
}
.mydiv img {
  // max-width: 201px;
  width: 100%;
  // max-height: 200px;
  height: 100px;
}
.mydiv {
 height: 100%;
  // width: 100%;
 // max-height: 200px;
// text-align: center;
 position: relative;
 z-index: 0;
 padding: 5px;
}
.close:hover{
  color: red;
}
.close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 999;
  padding-top: 3px;
padding-right: 3px;
  font-size: 18px;
  color: rgba(5, 108, 181, 0.65);
}
</style>